import React, { useState, useEffect } from "react";
import { FaTimes } from "react-icons/fa";
import BtnGuardar from "../../../components/buttons/BtnGuardar";
import BtnCancelar from "../../../components/buttons/BtnCancelar";
import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson, notify } from "../../../utils/http";

export default function CrearContrato({
  onClose = () => {},
  onCreated = () => {},
  embedded = false,
}) {
  // --- ESTADOS ---
  const [codigo, setCodigo] = useState("");
  const [descricaoTexto, setDescricaoTexto] = useState("");
  const [data, setData] = useState("");
  const [dataFechaini, setDataFechaini] = useState("");
  const [dataFechafin, setDataFechafin] = useState("");

  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const isValid = codigo.trim() !== "";

  useEffect(() => {
    if (embedded) return;
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose, embedded]);

  const handleSave = async () => {
    if (!isValid || saving) return;
    setSaving(true);
    setError("");

    if (dataFechaini && dataFechafin && dataFechafin < dataFechaini) {
      setError("La fecha fin no puede ser anterior a la fecha inicio");
      setSaving(false);
      return;
    }

    const payload = {
      codigo: codigo.trim(),
      descricaoTexto: descricaoTexto.trim() || null,
      data: data || null,               // yyyy-MM-dd
      dataFechaini: dataFechaini || null,
      dataFechafin: dataFechafin || null,
    };

    try {
      const created = await appFetchJson(apiRoutes.contratos.agregarUrl(), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      notify({ type: "success", message: "Contrato creado correctamente" });
      onCreated(created);
      if (!embedded) onClose();
      else {
        setCodigo("");
        setDescricaoTexto("");
        setData("");
        setDataFechaini("");
        setDataFechafin("");
      }
    } catch (e) {
      console.error("Error creando contrato:", e);
      setError(e?.message || "Error al crear el contrato.");
      notify({ type: "error", message: e?.message || "Error al crear el contrato." });
    } finally {
      setSaving(false);
    }
  };

  const content = (
    <>
      {!embedded && (
        <div className="modal-header flex justify-between items-center">
          <h2 className="section-title">Nuevo Contrato</h2>
          <button className="modal-close-x" onClick={onClose}>
            <FaTimes />
          </button>
        </div>
      )}

      <div className={embedded ? "" : "modal-body"}>
        {!embedded && (
          <p className="text-gray-600 mb-4 italic">
            Complete los datos para registrar un nuevo contrato.
          </p>
        )}

        <div className="form-grid">
          <div className="form-row col-span-2">
            <label className="form-label">Código del Contrato *</label>
            <input
              type="text"
              className="input w-full"
              value={codigo}
              onChange={(e) => setCodigo(e.target.value)}
              placeholder="Ej: S840016501-CHORTI"
            />
          </div>

          <div className="form-row col-span-2">
            <label className="form-label">Descripción</label>
            <textarea
              rows="3"
              className="input w-full"
              value={descricaoTexto}
              onChange={(e) => setDescricaoTexto(e.target.value)}
              placeholder="Texto descriptivo del contrato..."
            />
          </div>

          <div className="form-row col-span-2">
            <label className="form-label">Fecha del Contrato</label>
            <input
              type="date"
              className="input w-full"
              value={data}
              onChange={(e) => setData(e.target.value)}
            />
          </div>

          <div className="form-row col-span-2">
            <label className="form-label">Fecha Inicio</label>
            <input
              type="date"
              className="input w-full"
              value={dataFechaini}
              onChange={(e) => setDataFechaini(e.target.value)}
            />
          </div>

          <div className="form-row col-span-2">
            <label className="form-label">Fecha Fin</label>
            <input
              type="date"
              className="input w-full"
              value={dataFechafin}
              onChange={(e) => setDataFechafin(e.target.value)}
            />
            {dataFechaini && dataFechafin && dataFechafin < dataFechaini && (
              <div className="text-red-500 text-sm mt-1">
                La fecha fin no puede ser anterior a la fecha inicio
              </div>
            )}
          </div>
        </div>

        {error && <div className="text-red-600 mt-3 font-medium">{error}</div>}
      </div>

      <div className={embedded ? "mt-6 border-b pb-6" : "modal-footer"}>
        <div className="btn-row">
          <BtnGuardar
            label={saving ? "Guardando..." : embedded ? "Guardar y continuar" : "Guardar"}
            isValid={isValid && (!dataFechaini || !dataFechafin || dataFechafin >= dataFechaini)}
            saving={saving}
            onClick={handleSave}
          />
          {!embedded && <BtnCancelar onClick={onClose} />}
        </div>
      </div>
    </>
  );

  if (embedded) {
    return <div className="bg-white p-1">{content}</div>;
  }

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-panel-lg" onClick={(e) => e.stopPropagation()}>
        {content}
      </div>
    </div>
  );
}